module.exports = __webpack_public_path__ + "static/img/taoc.e14dff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taoc.png
// module id = wtj6
// module chunks = 0